import numeral from "numeral";
export const Sum = (list, col, isFormat) => {
    const sum = list.reduce((x, sum) => x + parseFloat(sum[col]), 0)
    return isFormat ? numeral(sum).format("0,0") : sum;
} 
